import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { UserActivity } from "../models/user-activity.model";

@Injectable()
export class UserActivityService {
  private endpoint: string = "/api/user-activities/";
  private pageVisitEndpoint: string = "/api/users/page-visit";

  constructor(private http: HttpClient) {}

  public saveUserActivity(userActivity: UserActivity) {
    try {
      userActivity.application = "SIILA";
      return this.http.post(this.endpoint, userActivity).toPromise();
    } catch (error) {
      console.error(error);
    }
  }

  public savePageVisit(pageVisited: string): Promise<any> {
    try {
      return this.http
        .post(this.pageVisitEndpoint, { pageVisited })
        .toPromise();
    } catch (error) {
      console.error(error);
      return Promise.resolve(null);
    }
  }
}
